/**
 * localStorage-backed drafts for the Rule Creation Wizard (RuleWizard).
 * Multiple named drafts, namespaced per tenant. Frontend-only, no backend involved.
 *
 * Draft shape: { id, name, currentStep, updatedAt, data }
 */

const tenantId = () => {
  try {
    return JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id ?? "unknown";
  } catch {
    return "unknown";
  }
};

const storageKey = () => `rule_wizard_drafts_${tenantId()}`;

export function listDrafts() {
  try {
    const raw = localStorage.getItem(storageKey());
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr)
      ? arr.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
      : [];
  } catch {
    return [];
  }
}

export function getDraft(id) {
  return listDrafts().find((d) => String(d.id) === String(id)) || null;
}

/**
 * Upsert a draft by id. Returns the saved draft (with fresh updatedAt).
 */
export function saveDraft(draft) {
  const drafts = listDrafts();
  const saved = { ...draft, updatedAt: Date.now() };
  const idx = drafts.findIndex((d) => String(d.id) === String(saved.id));
  if (idx >= 0) drafts[idx] = saved;
  else drafts.push(saved);
  try {
    localStorage.setItem(storageKey(), JSON.stringify(drafts));
  } catch (e) {
    console.error("ruleDrafts.saveDraft failed", e);
  }
  return saved;
}

export function deleteDraft(id) {
  const drafts = listDrafts().filter((d) => String(d.id) !== String(id));
  try {
    localStorage.setItem(storageKey(), JSON.stringify(drafts));
  } catch (e) {
    console.error("ruleDrafts.deleteDraft failed", e);
  }
}
